import { NavItem } from './Sidebar.types';

export const NAV_ITEMS: NavItem[] = [
  {
    title: 'eNO1 Sampling',
    children: [
      {
        title: 'eNO1 Message',
        path: '/eno1/message',
      },
      {
        title: 'eNO1 Upload',
        path: '/eno1/upload',
      },
      {
        title: 'eNO1 Status',
        path: '/eno1/status',
      },
      {
        title: 'NO2 Report',
        path: '/eno1/no2-report',
      },
      {
        title: 'NO3 Report',
        path: '/eno1/no3-report',
      },
      {
        title: 'NO3 Signed Forms',
        path: '/eno1/no3-signed-forms',
      },
      {
        title: 'Accuracy Report',
        path: '/eno1/accuracy-report',
      },
      {
        title: 'e55 Comparison',
        path: '/eno1/e55-comparison',
      },
    ]
  },
  {
    title: 'e53 Sampling',
    path: '/e53-sampling',
  },
  {
    title: 'Sampling Planning',
    path: '/sampling-planning',
  },
  {
    title: 'e55 Weights',
    path: '/e55-weights',
  },
  {
    title: 'e09 IBRS',
    path: '/e09-ibrs',
  },
  {
    title: 'IPC TD Accounting',
    path: '/ipc-td-accounting',
  },
  {
    title: 'UPU TD Accounting',
    path: '/upu-td-accounting',
  },
  {
    title: 'Settings',
    path: '/settings',
  },
]; 